<article [attr.aria-labelledby]="itemToDisplay.id"
         class="pcg-search-result-item pcg-search-result-item--simple pcg-contrast__border-main">
    <h2 [id]="itemToDisplay.id" class="pcg-search-result-item__title">
        <a [href]="itemToDisplay.url" class="pcg-search-result-item__title-link pcg-contrast__link">{{ itemToDisplay.name }}</a>
    </h2>
    <p [innerHtml]="itemToDisplay.contentPreview" class="pcg-search-result-item__desc pcg-contrast__color-main"></p>
</article>
